import React from 'react';
import styles from './styles/AccountSidebar.module.css';

const AccountSidebar = ({ activeTab, setActiveTab, userIsAccountOwner }) => {
    return (
        <nav className={styles.sidebar} aria-label="Account navigation">
            <button
                type="button"
                className={`${styles.sidebarItem} ${activeTab === 'Profile' ? styles.active : ''}`}
                onClick={() => setActiveTab('Profile')}
                aria-current={activeTab === 'Profile' ? 'page' : undefined}
            >
                Profile
            </button>
            <button
                type="button"
                className={`${styles.sidebarItem} ${activeTab === 'Scenarios' ? styles.active : ''}`}
                onClick={() => setActiveTab('Scenarios')}
                aria-current={activeTab === 'Scenarios' ? 'page' : undefined}
            >
                Scenarios
            </button>
            <button
                type="button"
                className={`${styles.sidebarItem} ${activeTab === 'SharedScenarios' ? styles.active : ''}`}
                onClick={() => setActiveTab('SharedScenarios')}
                aria-current={activeTab === 'SharedScenarios' ? 'page' : undefined}
            >
                Shared Scenarios
            </button>
            {userIsAccountOwner && (
                <>
                    <button
                        type="button"
                        className={`${styles.sidebarItem} ${activeTab === 'Logs' ? styles.active : ''}`}
                        onClick={() => setActiveTab('Logs')}
                        aria-current={activeTab === 'Logs' ? 'page' : undefined}
                    >
                        Logs
                    </button>
                    <button
                        type="button"
                        className={`${styles.sidebarItem} ${activeTab === 'Feedback' ? styles.active : ''}`}
                        onClick={() => setActiveTab('Feedback')}
                        aria-current={activeTab === 'Feedback' ? 'page' : undefined}
                    >
                        Feedback
                    </button>
                    <button
                        type="button"
                        className={`${styles.sidebarItem} ${activeTab === 'Settings' ? styles.active : ''}`}
                        onClick={() => setActiveTab('Settings')}
                        aria-current={activeTab === 'Settings' ? 'page' : undefined}
                    >
                        Settings
                    </button>
                </>
            )}
        </nav>
    );
};

export default AccountSidebar;
